import { React, useState, useEffect } from 'react';

import useToken from '../../util/useToken';

import { getAllGenomes } from '../../util/api';
import { permDeleteGenome } from '../../util/api';

import './DeleteGenome.css';

export default function DeleteGenome () {
    const { token, setToken, removeToken, validToken} = useToken();
    const [ genomes, setGenomes ] = useState({"results":[]})
    const [ selectedId, setSelectedId ] = useState(null);
    const [ refresh, setRefresh ] = useState(false);

    //Pagination variables
    const [ page, setPage ] = useState(1) 
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(5)
    const [ resultCount, setResultCount ] = useState(0);

    useEffect(() => {
        const handleGenomes = async () => {
            let info = await getAllGenomes(token, page, pageSize)
            setGenomes(info)
            setResultCount(parseInt(info["resultCount"]))

        }
        handleGenomes()
        setRefresh(false)
    }, [page, refresh, pageSize])


    const handleDelete = () => {
        permDeleteGenome(token, selectedId).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setRefresh(true)
                }
            })
        })
    }

    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id)
        }
    };

    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1 ){
            setPage(page - 1)
        }
    }

    return (
        <div className="container">
            <div className="genome-container">
                <h2>Genomes</h2>
                <div>
                    <div className="genome-table-buttons">
                        <div>
                            <button disabled={selectedId == null} onClick={() => {handleDelete();}}>Delete</button>
                        </div>
                        <div>
                            <button onClick={() => {handleBackClick()}}>{"<"}</button>
                            <input
                                className="page-input"
                                type="number"
                                value={editedPage}
                                onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                                onBlur={(event) => {
                                    const enteredPage = event.target.valueAsNumber || editedPage;
                                    const maxPage = Math.ceil(resultCount / pageSize);
                                    setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                    setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                }}
                            />
                            <button onClick={() => {handleFowardClick()}}>{">"}</button>
                        </div>
                    </div>
                    <table className="genome-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Date Sequenced</th>
                                <th>Data Location</th>
                                <th>Sangers</th>
                            </tr>
                        </thead>
                        <tbody>
                            {genomes?.results?.map((result) => (
                                <tr key={result.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedId === result.id}
                                            onChange={event => handleCheckboxChange(event, result.id)}
                                        />
                                    </td>
                                    <td>{result.dateSequenced?.replace("T", " ")} </td>
                                    <td>{result.dataLocation}</td>
                                    <td>{result.sangerCount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
            </div>
        </div>
    );
} 